/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type children_UpdateAllergyRequest = {
    comment?: string;
    name: string;
    severity?: children_UpdateAllergyRequest.severity;
};
export namespace children_UpdateAllergyRequest {
    export enum severity {
        MILD = 'MILD',
        MODERATE = 'MODERATE',
        SEVERE = 'SEVERE',
    }
}

